import { useEffect, useState } from "react";
import Modal from "./Modal";
import { formatDate } from "../utils/format";
import { listTrash, restoreTrashItem, deleteTrashItem } from "../api";
import notify from "../utils/notify";

export default function TrashPanel({ token, onClose, onChanged }) {
  const [items, setItems] = useState(null);

  const load = async () => {
    try {
      const { items } = await listTrash(token);
      setItems(items);
    } catch (e) {
      notify.error(e.message || "Failed to load trash");
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const restore = async (trashName) => {
    try {
      await restoreTrashItem(token, trashName);
      notify.success("Restored");
      setItems((prev) => prev.filter((i) => i.trashName !== trashName));
      onChanged();
    } catch (e) {
      notify.error(e.message || "Restore failed");
    }
  };

  const remove = async (trashName) => {
    if (!window.confirm("Permanently delete this item? This can't be undone.")) return;
    try {
      await deleteTrashItem(token, trashName);
      notify.success("Permanently deleted");
      setItems((prev) => prev.filter((i) => i.trashName !== trashName));
    } catch (e) {
      notify.error(e.message || "Delete failed");
    }
  };

  const emptyTrash = async () => {
    if (!items?.length) return;
    if (!window.confirm(`Permanently delete all ${items.length} item(s) in the trash?`)) return;
    for (const item of items) {
      try {
        await deleteTrashItem(token, item.trashName);
      } catch {
        // continue clearing the rest
      }
    }
    notify.success("Trash emptied");
    load();
  };

  return (
    <Modal title="Trash" onClose={onClose} width="560px">
      {items === null && <p>Loading…</p>}
      {items?.length === 0 && <p className="text-muted">Trash is empty.</p>}
      {items?.length > 0 && (
        <>
          <ul className="trash-list">
            {items.map((item) => (
              <li key={item.trashName}>
                <span className="trash-icon">{item.isDirectory ? "📂" : "📄"}</span>
                <span className="trash-name" title={item.name}>
                  {item.name}
                </span>
                <span className="trash-path text-muted">
                  {item.originalDir ? `from /${item.originalDir}` : "from /"}
                </span>
                <span className="trash-date text-muted">{formatDate(item.deletedAt)}</span>
                <button className="fm-btn" onClick={() => restore(item.trashName)}>
                  ↩️ Put back
                </button>
                <button className="fm-btn fm-btn-danger" onClick={() => remove(item.trashName)}>
                  ✖ Delete
                </button>
              </li>
            ))}
          </ul>
          <div className="trash-footer">
            <button className="fm-btn fm-btn-danger" onClick={emptyTrash}>
              Empty Trash
            </button>
          </div>
        </>
      )}
    </Modal>
  );
}
